/* ══════════════════════════════════════════════════════════════════════════
 * ABC-SE school shop — what the customer-facing shop looks like.
 * Shared by SchoolShop and the CreateShop review preview so the preview can
 * never drift from the real shop (banner photos, FOMO copy, card labels).
 * ══════════════════════════════════════════════════════════════════════════ */
import skolmerchDesktop from '../../../../assets/abc-se/school-shop/Skolmerch-Desktop.jpg';
import skolmerchMobile from '../../../../assets/abc-se/school-shop/Skolmerch-Mobile.jpg';
import overallsDesktop from '../../../../assets/abc-se/school-shop/Overalls-Desktop.jpg';
import overallsMobile from '../../../../assets/abc-se/school-shop/Overalls-Mobile.jpg';

// SecondaryBanner photos per shop type (menu item); Skolmerch is the fallback.
export const SKOLMERCH_BANNER = { backgroundImage: skolmerchDesktop, backgroundImageMobile: skolmerchMobile };
export const BANNER_IMAGES = {
  menu_1: SKOLMERCH_BANNER,
  menu_2: { backgroundImage: overallsDesktop, backgroundImageMobile: overallsMobile },
};

// FomoBlock copy: live countdown, or the fixed close date ("date" display mode).
export const FOMO_COUNTDOWN_TEMPLATE = 'Skynda! Webbshoppen stänger om {time}';
export const FOMO_DATE_TEMPLATE = 'Webbshoppen stänger {time}';
export const FOMO_UNITS = { day: 'd', hour: 't', minute: 'm' };

// ProductCard copy.
export const PACKAGE_DESCRIPTION = 'Paketlösning';
export const MORE_LABEL = 'fler';
